var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CloseCircleBulk, InfoCircleBulk, Refresh2Outline, TickCircleBulk, } from '../Icon';
import { message as messageAnt } from 'antd';
import React from 'react';
import _ from 'lodash';
var isArgsProps = function (content) {
    return _.isObject(content) && !!content.content;
};
var message = _.cloneDeep(messageAnt);
['success', 'info', 'error', 'warning', 'loading'].forEach(function (type) {
    var messageTypeFn = function (content, duration, onClose) {
        if (duration === void 0) { duration = 5; }
        var getIcon = function () {
            switch (type) {
                case 'success':
                    return React.createElement(TickCircleBulk, null);
                case 'error':
                    return React.createElement(CloseCircleBulk, null);
                case 'loading':
                    return React.createElement(Refresh2Outline, null);
                default:
                    return React.createElement(InfoCircleBulk, null);
            }
        };
        var config;
        if (isArgsProps(content)) {
            config = __assign({ icon: getIcon(), duration: duration }, content);
        }
        else {
            config = {
                content: content,
                duration: duration,
                onClose: onClose,
                type: type,
                icon: getIcon(),
            };
        }
        return messageAnt[type](config);
    };
    message[type] = messageTypeFn;
});
export default message;
//# sourceMappingURL=message.js.map